import { get } from "helpers/api_helper";

export const apiGetHelps = (params) => {
  return get("/master/faqs/", { params });
};
